import { Alert, Breadcrumb, Card, Col, EventHandler, Row } from "client/CommonComponents";
import './CreateBulkOrder.scss';
import OrderType from "./OrderType";
import OrderTypeSelection from "./OrderTypeSelection";
import MyCart from "./MyCart";

const CreateBulkOrder = (props:any) =>{
    const getCartCount = props?.getCartCount;
    const setdeletedItemFromCart = props?.setdeletedItemFromCart
    const deletedItemFromCart = props?.deletedItemFromCart
    
    return(
        <div className='user-assessment CustomerMyOrder mt-1'>
            <div className='breadCrumbBlock'>
                <EventHandler onEvent={props.handleClickBack} data-attribute="CreateBulkOrder_Default_EventHandler">
                    <div className='backButton mb-3'>
                        <span className="fa fa-chevron-left"></span>Back
                    </div>
                </EventHandler>
                <div className='breadcrumbList'>
                    <Breadcrumb items={props.breadcrumlist} maxDisplayedItems="5"  data-attribute="CreateBulkOrder_Default_Breadcrumb" />
                </div>
                {
                    props.mobile && !props.showCart ?
                    <EventHandler onEvent={props.mycartButton} data-attribute="CreateBulkOrder_Default_EventHandler_2">
                        <div className='mycartButton'>
                            My Cart ({getCartCount()})
                        </div>
                    </EventHandler> : null
                }
            </div>
            <Row>
                <Col xs={12} sm={12} md={12} lg={8} className={`createRequisition ${props.showCreateRequisition? '':'hideCreate'}`}>
                    <OrderType                           
                        setShowVehicleRequest={props?.setShowVehicleRequest}                        
                        setEquipmentRequest={props?.setEquipmentRequest}
                        SelectOrderType={props?.SelectOrderType} 
                        setShowOrderTypeDetail={props?.setShowOrderTypeDetail} 
                        showOrderTypeDetail={props?.showOrderTypeDetail}
                        setSelectOrderType={props?.setSelectOrderType}
                        isEditOrder={props?.isEditOrder}
                        setShowCart={props?.setShowCart}
                    />
                    <div className="mt-3">{props?.showOrderTypeDetail ?
                        props?.orderDetails?.map((vehicle: any) => {
                            return <OrderTypeSelection
                                setShowCartClicked={props?.setShowCartClicked}
                                setShowOrderTypeDetail={props?.setShowOrderTypeDetail}
                                SelectOrderType={props?.SelectOrderType}
                                setShowCart={props?.setShowCart}
                                vehicleRequest={props?.vehicleRequest}
                                equipmentRequest={props?.equipmentRequest}
                                setShowVehicleRequest={props?.setShowVehicleRequest}
                                setEquipmentRequest={props?.setEquipmentRequest}
                                vehicle={vehicle}
                                isEditOrder={props?.isEditOrder}
                                key = {vehicle?.requestIndex}
                                setdeletedItemFromCart = {setdeletedItemFromCart}
                                deletedItemFromCart = {deletedItemFromCart}
                            />
                        })
                        : ''}
                    </div>
                </Col>
                <Col xs={12} sm={12} md={12} lg={4} className='mycart-bulk-order mt-lg-0 mt-md-3 mt-0'>
                    {
                        props?.showCart ?  
                        <Card data-attribute="CreateBulkOrder_Default_Card">
                            {props?.showAlert?.isSucessfull && <Alert
                                className="alert-message successAlert"
                                showAlert={props?.showAlert?.isSucessfull}
                                dismissAlert={()=>props?.dismissAlert}
                                type="success"
                                text={ props?.showAlert?.label }
                             data-attribute="CreateBulkOrder_Default_Alerts" />}
                            <MyCart mobile={props?.mobile} setdeletedItemFromCart = {setdeletedItemFromCart} deletedItemFromCart = {deletedItemFromCart}/>
                        </Card> : ''
                    }                                    
                </Col>
            </Row>                 
        </div>
    )
}

export default CreateBulkOrder;